import { render, staticRenderFns } from "./ReferenceProcessingListItemDetails.vue?vue&type=template&id=7d1fe13e&scoped=true&"
import script from "./ReferenceProcessingListItemDetails.vue?vue&type=script&lang=js&"
export * from "./ReferenceProcessingListItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceProcessingListItemDetails.vue?vue&type=style&index=0&id=7d1fe13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fe13e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
